import React from "react";
import {
    List as AntList,
    Typography,
    Card,
    Row,
    Col,
    Button,
    Tabs,
    Icon,
    // Input,
    Popconfirm,
    Modal,
    message,
    Select,
    Checkbox
} from "antd";
import PropTypes from "prop-types";
import cx from "classnames";
import { DOCUMENT_CURRENT_STATUS } from "constants/enums";
import moment from "moment";
import UploadCompanyDoc from "forms/upload-company-doc-form";
const ListItem = AntList.Item;
const { Paragraph } = Typography;
const TabPane = Tabs.TabPane;
import DocumentService from "services/documents-service";
import "styles/document-review.css";
import getDocumentType from "../../components/helper";

class DocumentViewList extends React.PureComponent {
    fileUpload = false;

    state = {
        fileName: null,
        isClicked: null,
        selectedTab: "uploaded",
        showUploadModal: false,
        indeterminate: true,
        checkAll: true,
        checkedList: this.props.categoryList,
        filter: [],
        selectedFiles: [],
    };
    componentDidUpdate(prevProps){
        if(this.props.searchFilterVals != null && prevProps.searchFilterVals != this.props.searchFilterVals){
            this.setState({filter: [...this.props.searchFilterVals]});
        }
    }
    onTabChange = (e) => {
        this.setState({
            selectedTab: e,
        });
    }

    get _areFilesLoading() {
        return this.props.filesStatus !== "FETCHED";
    }

    getStatus = status => {
        if (status === DOCUMENT_CURRENT_STATUS.get("Pending Approval")) {
            return <div className={"pending-approval"}>Pending Approval</div>;
        }
        if (status === DOCUMENT_CURRENT_STATUS.get("Rejected")) {
            return <div className={"rejected-doc"}>Rejected</div>;
        }
        if (status === DOCUMENT_CURRENT_STATUS.get("Verified")) {
            return <div className={"approved-doc"}>Approved</div>;
        }
        if (status === DOCUMENT_CURRENT_STATUS.get("Requested")) {
            return <div className={"requested-doc"}>Requested</div>;
        }
        if (status === DOCUMENT_CURRENT_STATUS.get("Archived")) {
            return <div className={"requested-doc"}>Archived</div>;
        }
    };

    formatStatus = status => {
        if (status === "Pending") {
            return <div className={"pending-approval"}>Pending Approval</div>;
        }
        if (status === "Rejected") {
            return <div className={"rejected-doc"}>Rejected</div>;
        }
        if (status === "Approved") {
            return <div className={"approved-doc"}>Approved</div>;
        }
        if (status === "Archived") {
            return <div className={"approved-doc"}>Archived</div>;
        }
    }

    onFileNameEdit = (file, value) => {
        this.setState(
            {
                fileName: value
            },
            () => {
                this.props.changeName(
                    file.set("file_name", this.state.fileName)
                );
            }
        );
    };

    docFilter = (file) => {
        if (this.state.filter && this.state.filter.length) {
            let result = file && this.state.filter.find(_ => (file.name && file.name.toLocaleLowerCase().includes(_)) || (file.document && file.document.document_name && file.document.document_name.toLocaleLowerCase().includes(_)) || (file.document_name && file.document_name.toLocaleLowerCase().includes(_)));
            if (result) {
                return true;
            }
            return false;
        }
        return true;
    }

    onDocSearch = values => {
        this.setState({
            filter: values.map(_ => _.toLocaleLowerCase())
        });
        this.props.scrollPositionProp(null, values.map(_ => _.toLocaleLowerCase()));
    }

    get_aadhar_document_name= (file, document_option) => {
        if(file.document){
            if(file.document.id == 63 && document_option === 13){
                return "Aadhar Card M Back"
            }else if(file.document.id == 63 && document_option === 12){
                return "Aadhar Card M Front"
            }
            return file.document.document_name
        }
        return ""
    }
    getTitle = file => {
        return (
            <React.Fragment>
                <Row>
                    <Col
                        span={24}
                        className={
                            "d-flex flex-direction-row justify-content-space-between"
                        }>
                        <div
                            style={{
                                textOverflow: "ellipsis",
                                fontSize: 12,
                                fontWeight: 600,
                                color: "#000000"
                            }}>
                            <Paragraph
                                editable={{
                                    onChange: this.onFileNameEdit.bind(
                                        null,
                                        file
                                    )
                                }}>
                                {file.file_name}
                            </Paragraph>
                        </div>
                        {/* <div style={{
                            color: "#eb5757",
                            background: "transparent"
                        }}>
                            <Button type={"link"} icon={"download"} target={"_blank"} href={file.file} />
                            <Popconfirm
                                title="Are you sure delete this file?"
                                onConfirm={
                                    () => this.props.deleteRequestedDocument(file.id,file)
                                }
                                okText="Yes"
                                cancelText="No"
                            >
                                <a><Icon style={{
                                    cursor: "pointer"
                                }} type={"delete"} /></a>
                            </Popconfirm>
                        </div> */}
                    </Col>
                    <Col span={15}>
                        <div className={"doc-date"}>
                            {file &&
                                moment(file.modified_date).format(
                                    "MMM Do YYYY,    h:mm a"
                                )}
                        </div>
                    </Col>

                    <Col span={9}>{!this.props.hideRequestDocs ? this.getStatus(file.document_status) : this.formatStatus(file.status)}</Col>
                    <Col span={24}>
                        <span style={{
                            // color: "",
                            fontSize: "12px",
                            fontWeight: "600"
                        }}>
                            {this.props.hideRequestDocs ? `${file.applicant_name || "Document Type"}  :  ${getDocumentType(file)}` : `${this.get_aadhar_document_name(file, file.document_option)}`}
                            {/* {"Document Type: "}
                            {file.document && file.document.document_name} */}
                        </span>
                    </Col>
                    {this.props.hideRequestDocs && file.remarks && <Col className={"doc-date"} span={24} style={{
                        color: "#eb5757"
                    }}>
                        Remarks : {file.remarks}
                    </Col>}
                    {
                        file.document_status === DOCUMENT_CURRENT_STATUS.get("Rejected") && file.remarks && file.remarks !== " " ?
                            (<Col className={"doc-date"} span={24} style={{
                                color: "#eb5757"
                            }}>
                                {file.remarks}
                            </Col>) : null
                    }
                </Row>
            </React.Fragment>
        );
    };

    getRequestedDocTitle = (doc) => {
        return (
            <React.Fragment>
                <Col span={24} className={
                    "d-flex flex-direction-row justify-content-space-between"
                }>
                    <div
                        style={{
                            textOverflow: "ellipsis",
                            fontSize: 12,
                            fontWeight: 600,
                            color: "#000000"
                        }}
                    >
                        {doc.document_option ? doc.document_option == 12  ? "Aadhar - Front" : 
                            "Aadhar - Back" :  doc.document && doc.document.document_name}
                    </div>
                    {!this.props.noDocumentDeletePerm ? <div style={{
                        color: "#eb5757",
                        background: "transparent",
                        cursor: "pointer"
                    }}>
                        <Icon type={"delete"} onClick={() => this.props.deleteRequestedDocument(doc.id, doc)} />
                    </div> : null}
                </Col>
                <Col span={24} className={
                    "d-flex flex-direction-row justify-content-space-between"
                }>
                    <div className={"doc-date"}>
                        {doc &&
                            moment(doc.modified_date).format(
                                "MMM Do YYYY,    h:mm a"
                            )}
                    </div>
                    <div className={"doc-date"}>
                        {doc && !doc.request_remarks ? (
                            <Button type={"link"} size={"small"} disabled={this.props.recreditViewOnlyPermission} onClick={() => this.props.addRequestedRemark(doc.id, doc)}>{"Add Remark"}</Button>
                        ) : (
                            <React.Fragment>
                                <Icon size={"small"} type={"check-circle"} /> <span>Remark Added</span>
                            </React.Fragment>)
                        }
                    </div>
                </Col>
                {doc && doc.request_remarks ? (
                    <div className={"doc-date"}>
                        <Col span={20} style={{
                            color: "#eb5757"
                        }}>
                            {doc.request_remarks}
                        </Col>
                        <Col span={4}>
                            <Icon type={"edit"} onClick={() => this.props.addRequestedRemark(doc.id, doc)} />
                        </Col>
                    </div>
                ) : null}
            </React.Fragment>
        );
    }

    getStyle = _ => {
        if (this.state.isClicked === _.id) {
            return {
                background: "#e8fff1"
            };
        }
        return null;
    };

    isSelected = file => file && file.id === this.props.selectedFileId;

    selectFile = file => this.props.viewDoc(file);

    toggleUploadModal = () => {
        this.setState({
            showUploadModal: !this.state.showUploadModal
        });
    }

    // submitForm = (values) => {
    //     try {
    //         let file = new FormData();
    //         file.append('document' , values.document_type.toString().includes('-') ? values.document_type.split('-')[0] : values.document_type)
    //         file.append('document_option' , values.document_type.toString().includes('-') ? values.document_type.split('-')[1] : '')
    //         file.append('company' , this.props.companyId);
    //         file.append("file", values.files[0]);
    //         file.append("file_name", values.files[0]['name']);
    //         file.append("associate", values.associate || '');

    //         message.loading("Uploading Documents");
    //         DocumentService.uploadBulkDocumentsV2(this.props.caseId , file).then(_ => {
    //                 this.props.fetchFiles();
    //                 message.success("Document Uploaded");
    //                 this.toggleUploadModal();
    //             }).catch(() => {
    //                 message.error("Failed to Upload Documents");
    //                 this.toggleUploadModal();
    //             });
    //     } catch (err) {
    //         message.error("Failed to Upload Documents");
    //     }
    // }
    submitForm = (values) => {
        try {
            let file = new FormData();
            // file.append("files", values.files);
            values.files.map(_ => {
                file.append("files", _);
            });
            this.props.caseId && file.append("case" , this.props.caseId);
            message.loading("Uploading Documents");
            DocumentService.uploadBulkDocuments(this.props.companyId, file, values.document_type, values.associate).then(_ => {
                this.props.uploadFiles(_.data && _.data.map(_ => ({ ..._, company: this.props.companyId })));
                this.props.fetchFiles();
                message.success("Document Uploaded");
                this.toggleUploadModal();
            }).catch(() => {
                message.error("Failed to Upload Documents");
                this.toggleUploadModal();
            });
        } catch (err) {
            message.error("Failed to Upload Documents");
        }
    }


    // menu = (
    //     <React.Fragment>
    //         <div style={{ borderBottom: "1px solid #E9E9E9" }}>
    //             <Checkbox
    //                 indeterminate={this.state.indeterminate}
    //                 onChange={this.onCheckAllChange}
    //                 checked={this.state.checkAll}
    //             >
    //                 Check all
    //             </Checkbox>
    //         </div>
    //         <br />
    //         <Checkbox.Group
    //             options={this.props.categoryList}
    //             value={this.state.checkedList}
    //             onChange={this.onChange}
    //         />
    //     </React.Fragment>
    // );

    // getFilterDropdown = () => (
    //     <Dropdown overlay={this.menu}>
    //         {"Filter Documents By Type"}
    //     </Dropdown>
    // );

    onFileSelect = (fileId, type='archive') => {
        this.setState(prevState => {
            let key = "selectedFiles";
            let updatedSelectedFiles = [...prevState[key]];
    
            if (updatedSelectedFiles.includes(fileId)) {
                updatedSelectedFiles = updatedSelectedFiles.filter(id => id !== fileId);
            } else {
                updatedSelectedFiles.push(fileId);
            }
    
            return { [key]: updatedSelectedFiles };
        });
    };
    onScrollFn = (e) => {
        const scrollingPos = e.target?.scrollTop;
        this.props.scrollPositionProp(scrollingPos, this.state.filter);
    }
    onBulkAction = (actionType) => {
        const key = "selectedFiles";
        const selectedFiles = this.state[key];
    
        if (selectedFiles.length === 0) {
            message.warning(`No files selected for ${actionType === "restore" ? "restoration" : "deletion"}`);
            return;
        }
    
        DocumentService.actionDuplicateDocuments(selectedFiles, actionType)
            .then((res) => {
                message.success(`Selected files ${actionType === "restore" ? "restored" : "deleted"} successfully`);
                this.setState({ [key]: [] });
                this.props.fetchCompanyDocuments( this.props.caseId, this.props.companyId)
            })
            .catch(err => {
                message.error(`Failed to ${actionType === "restore" ? "restore" : "delete"} files`);
                console.error(`Error ${actionType} files:`, err);
            });
    };
    render() {
        const docsArchiveEnableStage = 11;
        return (
            <React.Fragment>
                <Modal
                    visible={this.state.showUploadModal}
                    footer={null}
                    closable={true}
                    onCancel={this.toggleUploadModal}
                    destroyOnClose
                    width={400}
                >
                    <div className={"p-5"}>
                        <UploadCompanyDoc
                            associates  = {this.props.associates}
                            onSubmit={this.submitForm}
                            recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                            files={this.props.files}
                        />
                    </div>
                </Modal>
                <Card
                    className={"upload-btn document-view-list"}
                    style={{
                        minHeight: "90vh"
                    }}
                    onScroll={this.onScrollFn}
                    extra={!this.props.hideRequestDocs && [
                        // eslint-disable-next-line react/jsx-key
                        <Button key={"upload"} size={"small"} icon={"file-add"} disabled={this.props.recreditViewOnlyPermission} onClick={this.toggleUploadModal}>
                            Upload More
                        </Button>,
                        <React.Fragment key={"requestParent"}>
                            <Button key={"request"} size={"small"} style={{
                                marginLeft: "10px"
                            }} disabled={this.props.recreditViewOnlyPermission}
                            onClick={() => this.props.openRequestModal()}>
                                Request Document
                            </Button>
                        </React.Fragment>
                    ]}>
                    <Row className={"doc-list-view doc-list-view-scroll"}>
                        <Col span={24} className={"mb-10"}>
                            {/* <Input.Search
                                onChange={this.onDocSearch}
                                placeholder={"Type Document Name to search"}
                            /> */}
                            <Select
                                className={"select-margin-0"}
                                mode={"tags"}
                                placeholder={(
                                    <div style={{ width: "100%" }} className={"d-flex justify-content-space-between align-items-center"}>
                                        <span>Select or Type Document Name to Search</span>
                                        <Icon type={"search"} />
                                    </div>
                                )}
                                onChange={(val) => this.onDocSearch(val)}
                                value={this.state.filter}
                                size={"default"}
                                style={{
                                    width: "100%"
                                }}
                            >
                                {this.props.categoryList && this.props.categoryList.map((_, k) => (
                                    <Select.Option key={k} value={_}>
                                        {_}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Col>
                        <Col span={24}>
                            <Tabs size={"small"} className={"list-view"} activeKey={this.state.selectedTab} onChange={this.onTabChange}>
                                <TabPane tab="Uploaded Docs" key={"uploaded"}>
                                {this.props.stageId === docsArchiveEnableStage && <Button type="primary" onClick={()=>this.onBulkAction("archive")} className="w-40 mb-7" style={{width:"35%"}} disabled={this.state.selectedFiles.length === 0}>
                                    Delete Selected
                                </Button>}
                                    {/* {this.props.categoryList && this.props.categoryList.length && this.getFilterDropdown()} */}
                                    <AntList grid={{ column: 1 }} loading={this._areFilesLoading}>
                                        {this.props.files.filter(_ => ![DOCUMENT_CURRENT_STATUS.get("Requested"), DOCUMENT_CURRENT_STATUS.get("Archived")].includes(_.document_status))
                                            .filter(this.docFilter)
                                            .sort((a, b) => {
                                                if (!this.props.hideRequestDocs) {
                                                    if (a.id > b.id) {
                                                        return -1;
                                                    }
                                                    if (a.id < b.id) {
                                                        return 1;
                                                    }
                                                    if (a.id === b.id) {
                                                        return 0;
                                                    }
                                                }
                                            })
                                            .map(_ => (
                                                <ListItem
                                                    className={cx(`item-unclicked ${this.props.stageId === docsArchiveEnableStage && 'd-flex justify-content-space-between'}`, {
                                                        ["clicked-item"]: this.isSelected(_)
                                                    })}
                                                    key={_.id}>
                                                    {this.props.stageId === docsArchiveEnableStage && <Checkbox 
                                                        checked={this.state.selectedFiles.includes(_.id)}
                                                        onChange={() => this.onFileSelect(_.id, 'archive')}
                                                    />}
                                                    <Card
                                                        size={"small"}
                                                        title={this.getTitle(_)}
                                                        className={
                                                            `padless-card no-shadow ${this.props.stageId === docsArchiveEnableStage ? 'w-90'  : "w-100"} doc-card file-actions`
                                                        }
                                                        actions={[
                                                            <Button
                                                                size={"small"}
                                                                key={"download"}
                                                                type={"link"}
                                                                icon={"download"}
                                                                target={"_blank"}
                                                                href={this.props.hideRequestDocs ? _.documents[0].file : _.file}
                                                            />,
                                                            // <React.Fragment key={"deleteMain"}>
                                                            //     {!this.props.hideRequestDocs && <Popconfirm
                                                            //         key={"delete"}
                                                            //         title="Are you sure delete this file?"
                                                            //         onConfirm={
                                                            //             () => this.props.deleteRequestedDocument(_.id, _)
                                                            //         }
                                                            //         okText="Yes"
                                                            //         cancelText="No"
                                                            //     >
                                                            //         <Button style={{
                                                            //             cursor: "pointer",
                                                            //             color: "#246079"
                                                            //         }} icon={"delete"} type={"link"} disabled={_.document_status === DOCUMENT_CURRENT_STATUS.get("Verified") || this.props.noDocumentDeletePerm} />
                                                            //     </Popconfirm>}
                                                            // </React.Fragment>,
                                                            <Button
                                                                key={"view"}
                                                                size={"small"}
                                                                type={"link"}
                                                                style={{
                                                                    color: "#246079"
                                                                }}
                                                                onClick={e => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    this.selectFile(_);
                                                                }}
                                                            >View</Button>
                                                        ]}
                                                    />
                                                </ListItem>
                                            ))
                                            .toArray()}
                                    </AntList>
                                </TabPane>
                                {!this.props.hideRequestDocs && <TabPane tab={"Requested Docs"} key={"requested"}>
                                    <AntList grid={{ column: 1 }} loading={this._areFilesLoading}>
                                        {this.props.files.filter(_ => _.document_status === DOCUMENT_CURRENT_STATUS.get("Requested"))
                                            .filter(this.docFilter)
                                            .sort((a, b) => {
                                                if (a.id > b.id) {
                                                    return -1;
                                                }
                                                if (a.id < b.id) {
                                                    return 1;
                                                }
                                                if (a.id === b.id) {
                                                    return 0;
                                                }
                                            })
                                            .map(_ => (
                                                <ListItem
                                                    className={cx("item-unclicked", {
                                                        ["clicked-item"]: this.isSelected(_)
                                                    })}
                                                    key={_.id}>
                                                    <Card
                                                        // onClick={() => this.selectFile(_)}
                                                        size={"small"}
                                                        title={this.getRequestedDocTitle(_)}
                                                        className={
                                                            "padless-card no-shadow w-100 doc-card"
                                                        }
                                                    />
                                                </ListItem>
                                            ))
                                            .toArray()}
                                    </AntList>
                                </TabPane>}
                                {this.props.stageId === docsArchiveEnableStage && <TabPane tab={"Archived Docs"} key={"archived"}>
                                    <Button type="primary" onClick={()=>this.onBulkAction("restore")} className="w-40 mb-7" disabled={this.state.selectedFiles.length === 0}>
                                        Restore Selected
                                    </Button>
                                    <AntList grid={{ column: 1 }} loading={this._areFilesLoading}>
                                        {this.props.files.filter(_ => _.document_status === DOCUMENT_CURRENT_STATUS.get("Archived"))
                                            .filter(this.docFilter)
                                            .sort((a, b) => {
                                                if (!this.props.hideRequestDocs) {
                                                    if (a.id > b.id) {
                                                        return -1;
                                                    }
                                                    if (a.id < b.id) {
                                                        return 1;
                                                    }
                                                    if (a.id === b.id) {
                                                        return 0;
                                                    }
                                                }
                                            })
                                            .map(_ => (
                                                <ListItem
                                                    className={cx("item-unclicked d-flex justify-content-space-between", {
                                                        ["clicked-item"]: this.isSelected(_)
                                                    })}
                                                    key={_.id}>
                                                    <Checkbox 
                                                        checked={this.state.selectedFiles.includes(_.id)}
                                                        onChange={() => this.onFileSelect(_.id, 'restore')}
                                                    />
                                                    <Card
                                                        size={"small"}
                                                        title={this.getTitle(_)}
                                                        className={
                                                            "padless-card no-shadow w-90 doc-card file-actions"
                                                        }
                                                        actions={[
                                                            <Button
                                                                size={"small"}
                                                                key={"download"}
                                                                type={"link"}
                                                                icon={"download"}
                                                                target={"_blank"}
                                                                href={this.props.hideRequestDocs ? _.documents[0].file : _.file}
                                                            />,
                                                            <Button
                                                                key={"view"}
                                                                size={"small"}
                                                                type={"link"}
                                                                style={{
                                                                    color: "#246079"
                                                                }}
                                                                onClick={e => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    this.selectFile(_);
                                                                }}
                                                            >View</Button>
                                                        ]}
                                                    />
                                                </ListItem>
                                            ))
                                            .toArray()}
                                    </AntList>
                                </TabPane>}
                            </Tabs>
                        </Col>
                    </Row>
                </Card>
            </React.Fragment>
        );
    }
}
DocumentViewList.propTypes = {
    companyId: PropTypes.number,
    files: PropTypes.object,
    selectedFileId: PropTypes.number,
    uploads: PropTypes.object,
    uploadFiles: PropTypes.func,
    invalidateDocument: PropTypes.func,
    caseId: PropTypes.number,
    viewDoc: PropTypes.func,
    changeName: PropTypes.func,
    isUserAllowedToEdit: PropTypes.bool,
    editDocumentAttached: PropTypes.bool,
    openRequestModal: PropTypes.func,
    scrollPositionProp: PropTypes.func,
    docMasterList: PropTypes.array,
    searchFilterVals: PropTypes.array,
    docMasterListStatus: PropTypes.string,
    deleteRequestedDocument: PropTypes.func,
    filesStatus: PropTypes.string,
    filter: PropTypes.string,
    addRequestedRemark: PropTypes.func,
    groupedDocMasterList: PropTypes.object,
    categoryList: PropTypes.object,
    stageId: PropTypes.number,
    noDocumentDeletePerm: PropTypes.bool,
    hideRequestDocs: PropTypes.bool,
    associates : PropTypes.array,
    fetchFiles : PropTypes.func,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default DocumentViewList;